import React from 'react';
import PriceBlog from '../../../../../frontend/elements/PriceBlog';
import './EntrepriseDashboard.css';

const TarifEntreprise = () => {
  return (
    <div className="entreprise-pricing-page">
      <div className="section-header">
        <h2>Tarifs Entreprise</h2>
        <p>Choisissez le plan qui convient à votre entreprise</p>
      </div>
      <div className="pricing-content card-like">
        <PriceBlog />
      </div>
    </div>
  );
};

export default TarifEntreprise;
